export const STORAGE_KEYS = { SESSION: "classmanage.session" };

export const APP_CONFIG = {
  social: { googleWebClientId: "", kakaoNativeKey: "" },
  sms: { cfUrl: "https://asia-northeast3-classcare-442b7.cloudfunctions.net/api/AuthCodeSend", label: "클래스케어" },
  testRange: { start: "01062141000", end: "01062141005" },
  kakaoCustomTokenUrl: "https://asia-northeast3-classcare-442b7.cloudfunctions.net/kakaoCustomToken",
  appleCustomTokenUrl: "https://asia-northeast3-classcare-442b7.cloudfunctions.net/appleCustomToken",
  resetPasswordUrl: "https://asia-northeast3-classcare-442b7.cloudfunctions.net/resetPassword",
};
